import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Tooltip from '@/popup/components/shared/Tooltip/Tooltip.vue'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'

type Props = {
  name?: string
  size?: string
  tooltip?: string
  disabled?: boolean
  color?: string
}

type Emits = {
  (event: 'on-click'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    name: { default: 'close-lg' },
    size: { default: '' },
    tooltip: { default: undefined },
    disabled: { type: Boolean, default: false },
    color: { default: 'var(--neutral-20)' }
  },
  emits: ["on-click"],
  setup(__props: any, { emit: __emit }) {



const emits = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tooltip, {
    class: _normalizeClass(`icon-button ${_ctx.disabled ? 'disabled' : ''}`),
    value: _ctx.tooltip,
    "offset-distance": _ctx.tooltip ? '5' : '0',
    onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.disabled && emits('on-click')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["icon-wrapper", _ctx.size])
      }, [
        _createVNode(SvgIcon, {
          name: _ctx.name,
          class: "icon",
          color: _ctx.color
        }, null, 8 /* PROPS */, ["name", "color"])
      ], 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "value", "offset-distance"]))
}
}

})